import API from '../index'

export default class STViscosityGrade {
    static async getGrades() {
        const api = await API();
        const { data } = await api.get('/stviscositygrade');
        return data.result;
    }
}
